import {StringUtils} from "./string.utils";
export class AppUtils {
  public static isUserLoggedIn(): boolean {
    let b: boolean = !StringUtils.isEmpty(localStorage.getItem("token")) && !StringUtils.isEmpty(localStorage.getItem("tracker"));
    return b;
  }

  public static removeToken() {
    localStorage.removeItem("token");
  }

  public static get_hrmin(dt: Date): string {
    return (dt.getHours() < 10 ? "0" + dt.getHours() : dt.getHours()) + ":" +
      (dt.getMinutes() < 10 ? "0" + dt.getMinutes() : dt.getMinutes());
  }

  public static formatDate(dt: Date): string {
    var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate();
    var mm = dt.getMonth() < 9 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1);
    var yyyy = dt.getFullYear();
    return dd + '/' + mm + '/' + yyyy;
  }

  public static getDt(tag: string): Date {
    var dt: Date = new Date();
    switch (tag) {
      case 'today':
        break;
      case 'lastmonth':
        dt = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 30);
        break;
      case 'nextmonth':
        dt = new Date(dt.getTime() + 1000 * 60 * 60 * 24 * 30);
        break;
      case 'lastweek':
        dt = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 7);
        break;
      case 'nextweek':
        dt = new Date(dt.getTime() + 1000 * 60 * 60 * 24 * 7);
        break;
      case 'yesterday':
        dt = new Date(dt.getTime() - 1000 * 60 * 60 * 24);
        break;
      case 'tomorrow':
        dt = new Date(dt.getTime() + 1000 * 60 * 60 * 24);
        break;
      default:
        dt = new Date();
        break;
    }
    return dt;
  }

  public static formatDtHyphen(ddmmyyyy: string): Date {
    var parts = ddmmyyyy.split('-');
    var dt = new Date(Number(parts[2]),Number(parts[1])-1,Number(parts[0]));
    return dt;
  }


  public static dateObject(dt: Date): any {
    var dd = dt.getDate() < 10 ? dt.getDate() : dt.getDate();
    var mm = dt.getMonth() < 9 ? (dt.getMonth() + 1) : (dt.getMonth() + 1);
    var yyyy = dt.getFullYear();
    var obj = {date: {year: yyyy, month: mm, day: dd}};
    return obj;
  }

  public static datelabel(dtstr: string): any {
    var obj = null;
    try {
      var dt = new Date(dtstr);
      var monthlabel = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var weekday: string[] = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var dd = dt.getDate() < 10 ? dt.getDate() : dt.getDate();
      var mm = dt.getMonth() < 9 ? (dt.getMonth() + 1) : (dt.getMonth() + 1);
      var yyyy = dt.getFullYear();
      obj = {year: yyyy, month: mm, day: dd, mlabel: monthlabel[dt.getMonth()], dayofweek: weekday[dt.getDay()]};
    } catch (err) {
    }
    return obj;
  }

  public static setTransientMsg(message: string) {
    localStorage.setItem("transient", message);
  }

  public static getApiMessage(): string {
    let apimessage = localStorage.getItem("transient");
    localStorage.removeItem("transient");
    return apimessage;
  }

  public static isEmail(field: string): boolean {
    var isEmail = (field.indexOf("@") > -1 && field.indexOf(".") > -1);
    return isEmail;
  }
}
